import { useAuth } from '@clerk/nextjs';

import { StaleTime } from 'queries/types';
import { useListFavourites } from 'services/api/restful/generated/accounts/accounts';
import type {
  FavouriteTimeframe,
  FavouriteType,
} from 'services/api/restful/generated/nofomoRestApi.schemas';

type FavouritesVariables = {
  type: FavouriteType;
  timeframe?: FavouriteTimeframe;
  limit?: number;
};

export const useFavourites = ({
  type,
  timeframe,
  limit,
}: FavouritesVariables) => {
  const { isSignedIn } = useAuth();

  const { data, isLoading, isError } = useListFavourites(
    { type, timeframe, limit },
    {
      query: {
        enabled: !!isSignedIn,
        staleTime: StaleTime.FIVE_MIN,
      },
    },
  );

  return {
    favourites: data?.data?.items ?? [],
    isLoading,
    isError,
  };
};
